module.exports = __webpack_public_path__ + "img/privilege6.1f58062b.png";